<template>
<div>
	<top :title="title" :color="color"></top>
	<div class="e-poster">
		<div class="banner-show">
			<div class="cover">
				<van-swipe :autoplay="3000" indicator-color="white" :show-indicators="false">
					<van-swipe-item v-for="(item,key,index) in swiperImg" :key="index">
					  <img :src="item.image" alt="">
					</van-swipe-item>
				</van-swipe>
			</div>
		</div>
        <div class="list">
            <!-- <div class="item" v-for="(item,index) in eposters" :key="index"> -->
            <div class="item" v-for="(value,key,index) in eposters" :key="index" @click="goTo(value.id)">
				<div class="cover" >
					<img :src="value.banner"/>
                    <!-- <h3>{{value.name}}</h3> -->
                    <h3 v-if="show_writer">
				        作者：<span v-for="(item,index) in value.writers" :key="index">{{item.name}}</span>
                    </h3>
				</div>   
			</div>
        </div>
	</div>
</div>
</template>
<script>
	import {MeetingsCarousel,Eposters,ButtonDetail,MeetingsDetails} from '../../../config/interface.js'
	import Top from '../components/Top'
	export default{
		components: {
    		Top
  		},
		data(){
			return{
                meeting_id:this.$route.query.meeting_id?this.$route.query.meeting_id:this.$route.query.MT_id,
				button_id:this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id,
				swiperImg:{},     //轮播图
                eposters:[],
				show_writer:0,
				title:'电子壁报',
				color:'#FFFFFF'
			}
		},
		mounted(){
			this.getMeetingCarousel();
            this.getPosters();
			this.getButtonData();
			this.getShow();
		},
		methods:{
			//会议轮播
			getMeetingCarousel(){
				const url=MeetingsCarousel;
				let params={
					meeting_id:this.meeting_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.swiperImg=data;
					}
				})
			},
            getPosters(){
                const url=Eposters;
				let params={
					meeting_id:this.meeting_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.eposters=data;
					}
				})
            },
			//是否显示作者
			getShow(){
                const url=MeetingsDetails;
				let params={
					meeting_id:this.meeting_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.show_writer=data.show_wallposter_writer;
					}
				})
            },
			//获取按钮信息
			getButtonData(){
				if(this.button_id){
					const url=ButtonDetail;
					let params={
                    	button_id:this.button_id
					}
					const method="POST";
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							document.title=res.data.share_title;
							this.title=res.data.name;
							if(res.data.top_color){
								this.color=res.data.top_color
							}else{
								this.color='#901D22'
							}
							if(common.is_weixin()){
								let data=res.data;
								common.wxShare(data.share_title,data.share_sub_title,data.share_img);
							}
						}
					})

				}
			},
			goTo(url){
				window.location.href="http://xgzx.admin.talkmed.com/showpdf?article_id="+url;
			}
		}
	}
</script>
<style lang="scss" scoped>
	.e-poster{
        padding: 10px;
		.banner-show{
			width:100%;
			.cover{
				width:100%;
				// margin-bottom:14px;
				img{
					width:100%;
				}
			}
		}
        .list{
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			.item{
				width:48%;
                border-radius: 10px;
                background: white;
                h3{
                    padding-left:5px;
                    line-height: 22px;
					font-size:14px;
                    // overflow:hidden; //超出的文本隐藏
                    // text-overflow:ellipsis; //溢出用省略号显示
                    // white-space:nowrap; //溢出不换行 （只显示一行）
					span{
						margin-right:3px;
					}
                }
                img{
                    border-radius: 10px 10px 0 0;
                }
			}
				
		}
        .item{
            margin-top:10px;
            .cover{
				position:relative;
			    margin:0 0 12px 0;
                border-radius: 10px;
				img{
					width:100%;
				}
			}
        }
		
	}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting/Eposter.vue